import { render, staticRenderFns } from "./assemblyTable.vue?vue&type=template&id=6866bbaf"
import script from "./assemblyTable.vue?vue&type=script&lang=js"
export * from "./assemblyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports